import React from 'react';
import { Table } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { requestIcon } from '../constants';
import WaitingIcon from './WaitingIcon';

const RequestStatusCell = ({ allowTransfer, request }) => (
  <Table.Cell>
    <FormattedMessage id={requestIcon(request, allowTransfer).message} />
    {request.waiting && <WaitingIcon className="float-r" />}
  </Table.Cell>
);

export default RequestStatusCell;
